
var CookieUtil = {
    "Get" : function (name) {
        "use strict";
        var cookies  = document.cookie.split(';'),
            cookie,
            value,
            i        = 0;

        name = name + "=";

        for (i; i < cookies.length; i++) {

            cookie = cookies[i];

            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }

            if (cookie.indexOf(name) == 0) {
                value = cookie.substring(name.length, cookie.length);
            }
        }

        return value;
    },

    "Set" : function (name, value, path, expiration) {
        "use strict";

        if (typeof path === 'undefined') {
            path = '/';
        }

        if (typeof expiration !== 'undefined') {
            expiration = " ;expires=" + expiration;
        } else {
            expiration = "";
        }

        document.cookie = name + '=' + value + "; path=" + path + expiration;
    },

    "Delete" : function (name) {
        "use strict";
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }
};

var UrlUtil = {
    "ParseHash" : function ($elem) {
        "use strict";
        return "#" + $elem.prop('href').split('#')[1];
    }
};

var ScrollUtil = {

    "HasScrolledIntoView" : function ($elem) {
        "use strict";
        var $window    = $(window),
            docViewTop = $window.scrollTop(),
            docViewBottom = docViewTop + $window.height(),
            elemTop = $elem.offset().top;

        return elemTop < docViewBottom ;
    },

    "ScrollTo" : function ($elem, speed, padding) {
        "use strict";

        var goTo = $elem.offset().top,
            defaultSpeed = 2000;

        if (typeof speed === 'undefined') {
            speed = defaultSpeed;
        }

        if (typeof padding === "undefined") {
            padding = 0;
        }

        $('html, body').animate({
            scrollTop: goTo + padding
        }, speed);
    },

    "ActiveSync" : function (syncGroup, syncActive) {
        "use strict";
        $(syncGroup).each(function () {
            var $grpElem = $(this);

            if ($grpElem.hasClass(syncActive)) {
                $grpElem.addClass('active');
            } else {
                $grpElem.removeClass('active');
            }
        });
    }
};

var TimelineUtil = {

    "ReCenterActive" : function ($elem) {
        "use strict";
        if ($elem.length > 0) {

            var $timelineCont = $("#timeline-container"),
                $timelineScale = $timelineCont.find('#timeline-scale'),
                $dragContainer = $timelineCont.find('.drag-container'),
                timelineDragContLeftOffset = $dragContainer.width() - $timelineScale.width(),
                timelineWidth = $timelineScale.width(),
                timelineLeft,
                $window = $(window);

            // Determine the new timeline scale left:
            timelineLeft = TimelineUtil.GetLeftInbounds(timelineDragContLeftOffset - (timelineWidth * ($elem.data('left-percent') /100)) + ($window.width() / 2) - 46);
            $timelineScale.addClass('auto-scrolled').css({"left" : timelineLeft + "px"});
            setTimeout(function () {$timelineScale.removeClass('auto-scrolled')}, 1000);

            // Set the current active icon
            $elem.siblings('.active').removeClass('active');
            $elem.addClass('active');
        }
    },

    "GetLeftInbounds" : function (newLeft) {
        "use strict";
        var $timelineCont = $("#timeline-container"),
            $timelineScale = $timelineCont.find('#timeline-scale'),
            $dragContainer = $timelineCont.find('.drag-container');

        // Right Side Limt
        if (newLeft < 46) {
            return 46
        }

        // Left Side Limit
        if (newLeft > ($dragContainer.width() - $timelineScale.width()) - 40) {
            return $dragContainer.width() - $timelineScale.width() - 40
        }

        return newLeft;
    }
};

var ResponsiveUtil = {

    large :  'large',
    medium :  'medium',
    small :  'small',
    smallP : 'small-portrait',
    portrait :  'portrait',
    landscape :  'landscape',
    bpMedium : 500,
    bpLarge : 800,
    viewPort : $(document),
    getHeaderHeight: function () {
        return $('header').height();
    },

    /**
     * Get the responsive size (large, medium, small) of the device
     * @returns {string}
     */
   getSize : function () {

        if (ResponsiveUtil.viewPort.innerWidth() > ResponsiveUtil.bpLarge) {
            return ResponsiveUtil.large;
        } else if (ResponsiveUtil.viewPort.innerWidth() > ResponsiveUtil.bpMedium) {
            return ResponsiveUtil.medium;
        } else {
            if (ResponsiveUtil.getOrientation() === ResponsiveUtil.portrait) {
                return ResponsiveUtil.smallP;
            } else {
                return ResponsiveUtil.small;
            }
        }
   },

    getHeight : function ()
    {
        "use strict";
        return ResponsiveUtil.viewPort.innerHeight();
    },

    getWidth : function ()
    {
        "use strict";
        return ResponsiveUtil.viewPort.innerWidth();
    },

    /**
     * Get the orientation (landscape or portrait) of the device
     * @returns {string}
     */
   getOrientation : function () {

        if (ResponsiveUtil.viewPort.outerWidth > ResponsiveUtil.viewPort.outerHeight) {
            return ResponsiveUtil.landscape;
        } else {
            return ResponsiveUtil.portrait;
        }
    }

};


var ImageUtil = {
    'OnLoad' : function (selector, callback)
    {
        "use strict";
        $(selector).each(function(){
            if (this.complete || /*for IE 10-*/ $(this).height() > 0) {
                callback.apply(this);
            }
            else {
                $(this).on('load', function(){
                    callback.apply(this);
                });
            }
        });

    }
};

var CustomEvent = {
    "createAll" : function () {
        CustomEvent.bindWindowResizeEnd();
    },

    "bindWindowResizeEnd" : function () {
        $(window).resize(function() {
            if(this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                $(this).trigger('resizeEnd');
            }, 50);
        });
    }
};

var Is = {
    "Safari" : function () {
        return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent));
    },
    "iOS" : function () {
        return   (/(iPad|iPhone|iPod).*safari/i.test(navigator.userAgent));
    },
    "Android" : function () {
        return (/android/i.test(navigator.userAgent));

    }
};